module.exports = __webpack_public_path__ + "src/assets/fonts/Mohaji-Icons.e98037.eot";